<template>
  <div class="location-page">
    <!-- Hero sectie -->
    <div class="hero-section">
      <div class="container">
        <h1>Tandarts Haaren | Tandzorg Gestel | Nabij Haaren en Esch</h1>
        <p class="lead">
          Zoekt u een <strong>tandarts in Haaren</strong> of omgeving? Tandzorg Gestel in Sint-Michielsgestel 
          ligt op slechts 8 minuten van Haaren centrum. Kleinschalige, persoonlijke tandheelkundige zorg 
          met alle moderne faciliteiten.
        </p>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <h2>Tandheelkundige zorg voor Haaren vanuit Sint-Michielsgestel</h2>
            <p>
              Patiënten uit <em>Haaren</em>, <em>Esch</em>, <em>Helvoirt</em> en <em>Udenhout</em> kiezen bewust voor 
              Tandzorg Gestel. Hoewel we net over de gemeentegrens liggen, bieden we de persoonlijke aandacht 
              en vakkundige zorg die past bij de waarden van deze regio.
            </p>

            <div class="benefits-section">
              <h3>Waarom patiënten uit Haaren voor ons kiezen</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="benefit-card">
                    <div class="benefit-icon">🏡</div>
                    <h4>Nabij en Vertrouwd</h4>
                    <p>Slechts 8 minuten vanuit Haaren centrum. Dichtbij genoeg om vertrouwd te zijn, 
                    ver genoeg om persoonlijke aandacht te garanderen.</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="benefit-card">
                    <div class="benefit-icon">👥</div>
                    <h4>Kleinschalig & Persoonlijk</h4>
                    <p>Geen massa-afhandeling. U krijgt een vaste behandelaar die uw mondgezondheid 
                    echt leert kennen en persoonlijke zorg biedt.</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="benefit-card">
                    <div class="benefit-icon">🚗</div>
                    <h4>Makkelijk Bereikbaar</h4>
                    <p>Via de N65 bent u er zo. Ruime gratis parkeergelegenheid direct voor de praktijk. 
                    Geen gedoe met parkeermeters of tijdlimieten.</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="benefit-card">
                    <div class="benefit-icon">⚡</div>
                    <h4>Modern & Efficiënt</h4>
                    <p>Digitale röntgen, 3D-scans en moderne behandeltechnieken. Efficiënte zorg 
                    zonder afbreuk aan kwaliteit of comfort.</p>
                  </div>
                </div>
              </div>
            </div>

            <h2>Bereikbaarheid vanuit Haaren en omgeving</h2>
            <div class="route-info">
              <div class="row">
                <div class="col-md-12">
                  <h3>🗺️ Routes vanuit verschillende locaties</h3>
                  <div class="route-grid">
                    <div class="route-item">
                      <strong>Vanuit Haaren centrum:</strong>
                      <p>Via Kerkstraat → N65 richting Den Bosch → Afslag Sint-Michielsgestel<br>
                      <span class="duration">⏱️ 8 minuten</span></p>
                    </div>
                    <div class="route-item">
                      <strong>Vanuit Esch:</strong>
                      <p>Via Provincialeweg → N65 → Afslag Sint-Michielsgestel<br>
                      <span class="duration">⏱️ 12 minuten</span></p>
                    </div>
                    <div class="route-item">
                      <strong>Vanuit Helvoirt:</strong>
                      <p>Via Bosscheweg → N65 → Afslag Sint-Michielsgestel<br>
                      <span class="duration">⏱️ 15 minuten</span></p>
                    </div>
                    <div class="route-item">
                      <strong>Vanuit Udenhout:</strong>
                      <p>Via A261 → N65 → Afslag Sint-Michielsgestel<br>
                      <span class="duration">⏱️ 18 minuten</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h2>Onze tandheelkundige diensten</h2>
            <p>
              Of u nu uit het centrum van Haaren komt of uit een van de buitengebieden, 
              bij Tandzorg Gestel krijgt u toegang tot alle moderne tandheelkundige behandelingen:
            </p>

            <div class="services-overview">
              <div class="row">
                <div class="col-md-6">
                  <div class="service-category">
                    <h4>🔍 Preventieve Zorg</h4>
                    <div class="service-list">
                      <div class="service-item">
                        <span class="service-name">Periodieke controles</span>
                        <span class="service-desc">Om problemen vroegtijdig te ontdekken</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Professionele reiniging</span>
                        <span class="service-desc">Door ervaren mondhygiënisten</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Fluoride behandeling</span>
                        <span class="service-desc">Extra bescherming tegen cariës</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-6">
                  <div class="service-category">
                    <h4>🛠️ Behandelingen</h4>
                    <div class="service-list">
                      <div class="service-item">
                        <span class="service-name">Vullingen & reparaties</span>
                        <span class="service-desc">Moderne, duurzame materialen</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Kronen & bruggen</span>
                        <span class="service-desc">Voor beschadigde of ontbrekende tanden</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Wortelkanaalbehandeling</span>
                        <span class="service-desc">Om uw eigen tanden te behouden</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="service-category">
                    <h4>✨ Cosmetische Zorg</h4>
                    <div class="service-list">
                      <div class="service-item">
                        <span class="service-name">Tandenbleken</span>
                        <span class="service-desc">Voor een stralende glimlach</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Veneers</span>
                        <span class="service-desc">Perfecte voortanden</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Composite bonding</span>
                        <span class="service-desc">Kleine correcties, groot effect</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="service-category">
                    <h4>👨‍👩‍👧‍👦 Familie Zorg</h4>
                    <div class="service-list">
                      <div class="service-item">
                        <span class="service-name">Kindertandheelkunde</span>
                        <span class="service-desc">Speciaal voor de allerkleinsten</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Orthodontie</span>
                        <span class="service-desc">Rechte tanden voor alle leeftijden</span>
                      </div>
                      <div class="service-item">
                        <span class="service-name">Seniorenzorg</span>
                        <span class="service-desc">Aangepaste zorg voor ouderen</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h2>Ervaringen van patiënten uit Haaren</h2>
            <div class="testimonials">
              <div class="testimonial">
                <div class="testimonial-header">
                  <div class="rating">⭐⭐⭐⭐⭐</div>
                  <div class="author">Familie Janssen - Haaren</div>
                </div>
                <blockquote>
                  "We komen al 3 jaar vanuit Haaren naar Tandzorg Gestel en zijn er zeer tevreden over. 
                  De reisafstand is minimaal, maar het verschil in service is enorm. Persoonlijke aandacht, 
                  moderne apparatuur en een team dat echt om je geeft."
                </blockquote>
              </div>

              <div class="testimonial">
                <div class="testimonial-header">
                  <div class="rating">⭐⭐⭐⭐⭐</div>
                  <div class="author">Marieke V. - Esch</div>
                </div>
                <blockquote>
                  "Voor mijn kinderen was dit de perfecte keuze. Ze gaan met plezier naar de tandarts. 
                  Vanuit Esch ben je er zo, en de praktijk is echt ingericht op gezinnen met kinderen."
                </blockquote>
              </div>
            </div>

            <h2>Specialistische zorg dicht bij huis</h2>
            <p>
              Een van de voordelen van Tandzorg Gestel voor patiënten uit Haaren is dat we veel 
              specialistische behandelingen in eigen huis kunnen uitvoeren:
            </p>

            <div class="specialties-grid">
              <div class="specialty-card">
                <div class="specialty-icon">🔬</div>
                <h4>Endodontie</h4>
                <p>Wortelkanaalbehandelingen met moderne technieken en materialen voor optimaal resultaat.</p>
                <router-link to="/wortelkanaalbehandeling" class="specialty-link">Meer informatie →</router-link>
              </div>
              
              <div class="specialty-card">
                <div class="specialty-icon">💎</div>
                <h4>Cosmetische Tandheelkunde</h4>
                <p>Van tandenbleken tot veneers - voor de perfecte glimlach die bij u past.</p>
                <router-link to="/cosmetische-tandheelkunde" class="specialty-link">Meer informatie →</router-link>
              </div>
              
              <div class="specialty-card">
                <div class="specialty-icon">🧼</div>
                <h4>Mondhygiëne</h4>
                <p>Professionele reiniging en preventieve zorg door ervaren mondhygiënisten.</p>
                <router-link to="/mondhygiene" class="specialty-link">Meer informatie →</router-link>
              </div>
            </div>

            <div class="final-cta">
              <h2>Nieuwsgierig naar onze aanpak?</h2>
              <p>
                Overweegt u om over te stappen naar een praktijk die écht tijd voor u heeft? 
                Plan een kennismakingsafspraak en ervaar zelf het verschil van persoonlijke tandheelkundige zorg.
              </p>
              <div class="cta-buttons">
                <router-link to="/afspraak-maken" class="btn btn-primary">
                  📅 Afspraak Maken
                </router-link>
                <router-link to="/contact" class="btn btn-secondary">
                  📞 Meer Informatie
                </router-link>
              </div>
            </div>
          </div>

          <!-- Sidebar -->
          <div class="col-md-4">
            <div class="sidebar">
              <div class="location-card">
                <h3>📍 Locatie & Contact</h3>
                <div class="location-details">
                  <p><strong>Tandzorg Gestel</strong><br>
                  Dr. Erensstraat 45<br>
                  5271 BC Sint-Michielsgestel</p>
                  
                  <div class="distance-info">
                    <h4>Afstanden vanuit:</h4>
                    <ul>
                      <li>Haaren centrum: <strong>8 min</strong></li>
                      <li>Esch: <strong>12 min</strong></li>
                      <li>Helvoirt: <strong>15 min</strong></li>
                      <li>Udenhout: <strong>18 min</strong></li>
                    </ul>
                  </div>
                  
                  <div class="contact-info">
                    <p><strong>Telefoon:</strong> 073 - 551 4004<br>
                    <strong>Email:</strong> info@tandzorggestel.nl</p>
                  </div>
                </div>
              </div>

              <div class="hours-card">
                <h3>🕒 Openingstijden</h3>
                <div class="hours-table">
                  <div class="hours-row">
                    <span class="day">Ma</span><span class="hours">8:00 - 17:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Di</span><span class="hours">8:00 - 20:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Wo</span><span class="hours">8:00 - 17:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Do</span><span class="hours">8:00 - 20:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Vr</span><span class="hours">8:00 - 17:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Za</span><span class="hours">9:00 - 13:00</span>
                  </div>
                </div>
                <p class="hours-note">
                  <strong>Flexibele afspraken mogelijk</strong><br>
                  Ook buiten reguliere tijden op afspraak.
                </p>
              </div>

              <div class="why-us-card">
                <h3>🏆 Waarom Tandzorg Gestel?</h3>
                <ul class="why-us-list">
                  <li>✓ Lid van De Lieve Tandarts netwerk</li>
                  <li>✓ Persoonlijke aandacht en continuïteit</li>
                  <li>✓ Moderne digitale tandheelkunde</li>
                  <li>✓ Ervaren team van specialisten</li>
                  <li>✓ Kindvriendelijke praktijk</li>
                  <li>✓ Gratis parkeren voor de deur</li>
                  <li>✓ Spoedgevallen altijd welkom</li>
                </ul>
              </div>

              <div class="quick-links-card">
                <h3>🔗 Handige Links</h3>
                <div class="quick-links">
                  <router-link to="/afspraak-maken" class="quick-link">
                    📅 Online Afspraak
                  </router-link>
                  <router-link to="/spoed" class="quick-link emergency">
                    🚨 Spoedgevallen
                  </router-link>
                  <router-link to="/veelgestelde-vragen" class="quick-link">
                    ❓ Veelgestelde Vragen
                  </router-link>
                  <router-link to="/het-team" class="quick-link">
                    👥 Ons Team
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TandartsHaaren',
  mounted() {
    document.title = 'Tandarts Haaren | Tandzorg Gestel Sint-Michielsgestel | 8 Min Rijden'
    
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        'Tandarts Haaren? Tandzorg Gestel in Sint-Michielsgestel ligt op 8 minuten van Haaren. Persoonlijke zorg, moderne technieken, gratis parkeren. Ook Esch, Helvoirt en Udenhout.')
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 
        'tandarts Haaren, tandarts 5076, tandarts Esch, tandarts Helvoirt, tandarts Udenhout, tandheelkunde Haaren, Sint-Michielsgestel, Tandzorg Gestel')
    }
  }
}
</script>

<style scoped>
.location-page {
  padding-top: 120px;
}

.hero-section {
  background: linear-gradient(135deg, #f0f8f0 0%, #e6f3ff 100%);
  padding: 60px 0;
  margin-bottom: 40px;
}

.hero-section h1 {
  font-size: 2.5rem;
  color: var(--black);
  margin-bottom: 1rem;
  font-weight: 700;
}

.lead {
  font-size: 1.3rem;
  line-height: 1.6;
  color: var(--light-color);
}

.benefits-section {
  margin: 3rem 0;
}

.benefit-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
  text-align: center;
  transition: transform 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-5px);
}

.benefit-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.benefit-card h4 {
  color: var(--blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.benefit-card p {
  color: var(--light-color);
  line-height: 1.6;
}

.route-info {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin: 3rem 0;
}

.route-info h3 {
  color: var(--blue);
  margin-bottom: 2rem;
}

.route-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.route-item {
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f9f9f9;
}

.route-item strong {
  color: var(--blue);
  display: block;
  margin-bottom: 0.5rem;
}

.route-item p {
  margin: 0;
  color: var(--light-color);
  line-height: 1.5;
}

.duration {
  color: var(--blue);
  font-weight: 600;
  font-size: 0.9rem;
}

.services-overview {
  margin: 3rem 0;
}

.service-category {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.service-category h4 {
  color: var(--blue);
  margin-bottom: 1.5rem;
  font-size: 1.4rem;
}

.service-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.service-item {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid var(--blue);
}

.service-name {
  font-weight: 600;
  color: var(--black);
  margin-bottom: 0.3rem;
}

.service-desc {
  font-size: 0.9rem;
  color: var(--light-color);
}

.testimonials {
  margin: 3rem 0;
}

.testimonial {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
  border-left: 4px solid var(--blue);
}

.testimonial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.rating {
  font-size: 1.1rem;
}

.author {
  font-weight: 600;
  color: var(--blue);
  font-size: 0.9rem;
}

.testimonial blockquote {
  font-style: italic;
  color: var(--light-color);
  line-height: 1.6;
  margin: 0;
}

.specialties-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.specialty-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  text-align: center;
  transition: transform 0.3s ease;
}

.specialty-card:hover {
  transform: translateY(-5px);
}

.specialty-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.specialty-card h4 {
  color: var(--blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.specialty-card p {
  color: var(--light-color);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.specialty-link {
  color: var(--blue);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.specialty-link:hover {
  color: var(--dark-blue);
}

.final-cta {
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
  padding: 3rem;
  border-radius: 12px;
  text-align: center;
  margin: 3rem 0;
}

.final-cta h2 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: var(--blue);
  color: white;
  border: 2px solid var(--blue);
}

.btn-primary:hover {
  background: var(--dark-blue);
  transform: translateY(-2px);
}

.btn-secondary {
  background: white;
  color: var(--blue);
  border: 2px solid var(--blue);
}

.btn-secondary:hover {
  background: var(--blue);
  color: white;
}

/* Sidebar Styles */
.sidebar {
  position: sticky;
  top: 130px;
}

.location-card,
.hours-card,
.why-us-card,
.quick-links-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.location-card h3,
.hours-card h3,
.why-us-card h3,
.quick-links-card h3 {
  color: var(--blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.distance-info h4 {
  color: var(--black);
  font-size: 1rem;
  margin: 1rem 0 0.5rem 0;
}

.distance-info ul {
  list-style: none;
  padding: 0;
}

.distance-info li {
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.distance-info li:last-child {
  border-bottom: none;
}

.hours-table {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hours-row {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.hours-row:last-child {
  border-bottom: none;
}

.day {
  font-weight: 600;
  color: var(--black);
  width: 30px;
}

.hours {
  color: var(--light-color);
}

.hours-note {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;
  font-size: 0.9rem;
  color: var(--light-color);
}

.why-us-list {
  list-style: none;
  padding: 0;
}

.why-us-list li {
  padding: 0.4rem 0;
  color: var(--light-color);
}

.quick-links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.quick-link {
  display: block;
  padding: 0.8rem;
  background: #f8f9fa;
  color: var(--blue);
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.quick-link:hover {
  background: var(--blue);
  color: white;
  transform: translateX(5px);
}

.quick-link.emergency {
  background: #fff5f5;
  color: #dc3545;
}

.quick-link.emergency:hover {
  background: #dc3545;
  color: white;
}

@media (max-width: 768px) {
  .location-page {
    padding-top: 100px;
  }
  
  .hero-section h1 {
    font-size: 2rem;
  }
  
  .route-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .specialties-grid {
    grid-template-columns: 1fr;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 100%;
    max-width: 250px;
    justify-content: center;
  }
  
  .sidebar {
    position: static;
    margin-top: 3rem;
  }
}
</style>
